import { createContext, PropsWithChildren } from 'react';

interface AppContext {
	language: string;
	pageId?: string;
}

interface AppContextProviderProps extends PropsWithChildren {
	language: string;
	pageId?: string;
}

export const AppContext = createContext<AppContext | null>(null);

export const AppContextProvider = ({
	language,
	pageId,
	children,
}: AppContextProviderProps) => {
	return (
		<AppContext.Provider
			value={{
				language: language,
				pageId: pageId,
			}}
		>
			{children}
		</AppContext.Provider>
	);
};
